import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { IconColor, IconModule } from '@freelancer/ui/icon';
import {
  RibbonColor,
  RibbonIconName,
  RibbonOrientation,
  RibbonPlacement,
} from './ribbon.types';

@Component({
  standalone: true,
  imports: [IconModule],
  selector: 'fl-ribbon',
  template: `
    @if (icon) {
      <fl-icon
        [label]="iconLabel"
        [name]="icon"
        [color]="IconColor.LIGHT"
        [useIconFont]="true"
        [fillIconFont]="true"
      ></fl-icon>
    }
    <span class="text-light text-body-16 font-bold">
      <ng-content></ng-content>
    </span>
  `,
  styleUrls: ['./ribbon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RibbonComponent {
  IconColor = IconColor;

  @Input() iconLabel?: string;

  @HostBinding('attr.data-color')
  @Input()
  color: RibbonColor = RibbonColor.PRIMARY;

  @HostBinding('attr.data-icon')
  @Input()
  icon?: RibbonIconName;

  @HostBinding('attr.data-orientation')
  @Input()
  orientation = RibbonOrientation.HORIZONTAL;

  @HostBinding('attr.data-placement')
  @Input()
  placement: RibbonPlacement = RibbonPlacement.RIGHT;

  @HostBinding('attr.data-placement-tablet')
  @Input()
  placementTablet?: RibbonPlacement;

  @HostBinding('attr.data-placement-desktop')
  @Input()
  placementDesktop?: RibbonPlacement;
}
